<div class='tile-wrapper'>
    <a class='view-link' (click)="openContract(contract.uid)">
        <div class='content'>
            <div class='report-header'>
                <div class='sticker {{parsed.cssClass}}'>
                    {{parsed.overall}}
                </div>

                <div class="chart-wrapper">
                    <canvas [id]="chartId"></canvas>
                </div>

            </div>
            <div class="chart-legend" id="{{chartId}}-legend">
            </div>

            <div class='title-wrapper'>
                <div class="title">
                    <h2>{{ contract.name | truncate:20 }}</h2>
                </div>
            </div>
        </div>
    </a>

    <div class='actions-wrapper'>
        <span class='updated-date'>
            {{'CreatedOn' | translate }} {{ contract.creationDate | date }}
        </span>
        <a [matMenuTriggerFor]='actionsMenu'>
            <mat-icon>more_vert</mat-icon>
        </a>

        <mat-menu #actionsMenu="matMenu">
            <button class="menu-item" mat-menu-item (click)='editName()'>{{'EditName' | translate }}</button>
            <button class="menu-item" mat-menu-item (click)='deleteWorkflow(contract.uid)'>{{'DeleteContract'|translate }}</button>
        </mat-menu>
    </div>
</div>